import React from 'react';
import { Label } from 'semantic-ui-react';

const getInitials = (name) => {
  const nameTokens = name.trim().split(' ');
  if (nameTokens.length > 1) {
    return nameTokens[0][0] + nameTokens[nameTokens.length -1][0];
  }
  return nameTokens[0][0];
};

const UserAvatar = ({name, useSvg, ...props}) => {
  const { style, ...otherProps } = props;
  if (useSvg) {
    return (
      <svg viewBox="0 0 16 16" style={{fontSize: 6, fontWeight: 700, fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif", ...style}} {...otherProps}>
        <g>
          <circle cx={8} cy={8} r={7} fill="#00b58d" />
          <text x={8} y={8} alignmentBaseline="central" fill="white" textAnchor="middle">{getInitials(name)}</text>
        </g>
      </svg>
    );
  }
  return (
    <Label circular color="teal" {...props}>
      {getInitials(name)}
    </Label>
  );
};

export default UserAvatar
